module.exports = __webpack_public_path__ + "img/ho-facil-white.4e0e41c5.png";